import {
    FETCH_NOTIFICATION_EVENT_REQUEST,
    FETCH_NOTIFICATION_EVENT_SUCCESS,
    FETCH_NOTIFICATION_EVENT_ERROR,
    ADD_COMM_PROFILE_REQUEST,
    ADD_COMM_PROFILE_SUCCESS,
    ADD_COMM_PROFILE_ERROR,
    FETCH_COMM_PROFILE_REQUEST,
    FETCH_COMM_PROFILE_SUCCESS,
    FETCH_COMM_PROFILE_ERROR,
    UPDATE_COMM_PROFILE_REQUEST,
    UPDATE_COMM_PROFILE_SUCCESS,
    UPDATE_COMM_PROFILE_ERROR,
    HIDE_COMM_PROFILE_LOADER,
    SHOW_COMM_PROFILE_LOADER,
} from './commProfile.constants';

export const fetchNotificationEventRequest = () => ({
    type: FETCH_NOTIFICATION_EVENT_REQUEST,
});

export const fetchNotificationEventSuccess = payload => ({
    type: FETCH_NOTIFICATION_EVENT_SUCCESS,
    payload,
});

export const fetchNotificationEventError = payload => ({
    type: FETCH_NOTIFICATION_EVENT_ERROR,
    payload,
});

export const addCommProfileRequest = payload => ({
    type: ADD_COMM_PROFILE_REQUEST,
    payload,
});

export const addCommProfileSuccess = payload => ({
    type: ADD_COMM_PROFILE_SUCCESS,
    payload,
});

export const addCommProfileError = payload => ({
    type: ADD_COMM_PROFILE_ERROR,
    payload,
});

export const fetchCommProfileRequest = () => ({
    type: FETCH_COMM_PROFILE_REQUEST,
});

export const fetchCommProfileSuccess = payload => ({
    type: FETCH_COMM_PROFILE_SUCCESS,
    payload,
});

export const fetchCommProfileError = payload => ({
    type: FETCH_COMM_PROFILE_ERROR,
    payload,
});

export const updateCommProfileRequest = payload => ({
    type: UPDATE_COMM_PROFILE_REQUEST,
    payload,
});

export const updateCommProfileSuccess = payload => ({
    type: UPDATE_COMM_PROFILE_SUCCESS,
    payload,
});

export const updateCommProfileError = payload => ({
    type: UPDATE_COMM_PROFILE_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_COMM_PROFILE_LOADER });

export const hideLoader = () => ({ type: HIDE_COMM_PROFILE_LOADER });
